import React from "react";

// Simple 3-step progress indicator for the CSV wizard.
export default function CsvStepIndicator({ current }) {
  const steps = [
    { n: 1, label: "Upload" },
    { n: 2, label: "Map fields" },
    { n: 3, label: "Result" },
  ];
  return (
    <div className="mt-4 flex items-center gap-2" data-testid="wiz-steps">
      {steps.map((s) => (
        <div key={s.n}
          className={`px-3 py-1 border border-black text-xs uppercase tracking-widest ${current === s.n ? "bg-black text-white" : ""}`}>
          {s.n}. {s.label}
        </div>
      ))}
    </div>
  );
}
